import { cartReducer } from '@/screens/Cart';
import { categoryReducer } from '@/screens/Category';
import { favoritesReducer } from '@/screens/Favorites';
import { placingOrderReducer } from '@/screens/PlacingOrder';
import { productReducer } from '@/screens/Product';
import { feedbackReducer } from '@/widgets/Feedback';
import { combineReducers, configureStore, UnknownAction } from '@reduxjs/toolkit';

import { comparisonReducer } from '@screens/Comparison';
import { personalAccountInfoReducer } from '@screens/PersonalAccount';
import { screenSizeTrackingReducer } from '@shared/ui/ScreenSizeTracking';
import { alertReducer } from '@widgets/AlertModal';
import { authReducer } from '@widgets/Auth';
import { callModalReducer } from '@widgets/CallModal';
import { categoriesModalReducer } from '@widgets/CategoriesMenu';
import { cookieModalReducer } from '@widgets/CookieModals';
import { headerReducer } from '@widgets/Header';

const appReducer = combineReducers({
  feedback: feedbackReducer,
  category: categoryReducer,
  categoriesModal: categoriesModalReducer,
  header: headerReducer,
  alert: alertReducer,
  product: productReducer,
  screenSizeTracking: screenSizeTrackingReducer,
  favorites: favoritesReducer,
  cart: cartReducer,
  placingOrder: placingOrderReducer,
  comparison: comparisonReducer,
  callModal: callModalReducer,
  cookieModal: cookieModalReducer,
  auth: authReducer,
  personalAccountInfo: personalAccountInfoReducer
});

export type RootState = ReturnType<typeof appReducer>;

export const rootReducer = (state: Partial<RootState> | undefined, action: UnknownAction) => {
  if (action.type === 'RESET_STORE') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
}

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
